'use client';
import { useContext } from 'react';
import { LandPurchaseContext } from '../../contexts/land-purchase-context';

const LandQuantityInput = () => {
  const { landQuantity, updateLandQuantity } = useContext(LandPurchaseContext);

  return (
    <>
      <div className="flex h-10 items-start justify-end">
        <button
          className="flex h-full items-center justify-center gap-2 rounded-3xl border border-neutral-50 px-3 text-base font-normal leading-normal text-neutral-50"
          onClick={() => updateLandQuantity(1)}
        >
          Clear
        </button>
      </div>
      <div className="inline-flex h-10 w-24 items-center justify-center rounded-3xl border border-slate-700 bg-gray-900 p-2 font-semibold">
        <button onClick={() => updateLandQuantity(landQuantity - 1)}>
          <span className=" m-auto text-2xl text-white">-</span>
        </button>
        <input
          className="flex w-full cursor-default items-center bg-gray-900 text-center text-base text-white outline-none"
          name="custom-input-number"
          value={landQuantity}
          onChange={e => updateLandQuantity(parseInt(e.target.value))}
        ></input>
        <button onClick={() => updateLandQuantity(landQuantity + 1)}>
          <span className="m-auto text-2xl text-white">+</span>
        </button>
      </div>
    </>
  );
};

export default LandQuantityInput;
